; (function ($) {

    'use strict';

    $(document).ready(function () {

        $('.form.form-recruitment').each(function () {
            (function () {
                var xhr;
                var inputs = {
                    address: $('#form-recruitment-field-address'),
                    label: $('#form-recruitment-field-address-label'),
                    name: $('#form-recruitment-field-address-name'),
                    postcode: $('#form-recruitment-field-address-postcode'),
                    city: $('#form-recruitment-field-address-city')
                };
                inputs.address.on('keydown', function (event) {
                    inputs.label.val(null);
                    inputs.name.val(null);
                    inputs.postcode.val(null);
                    inputs.city.val(null);
                });
                inputs.address.autoComplete({
                    delay: 0,
                    cache: false,
                    source: function (term, response) {
                        try { xhr.abort(); } catch (e) { }
                        xhr = $.getJSON(
                            'https://api-adresse.data.gouv.fr/search/',
                            { q: term, limit: 3 },
                            function (data) {
                                response(data.features);
                            }
                        );
                    },
                    renderItem: function (feature, search) {
                        search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
                        var regexp = new RegExp("(" + search.split(' ').join('|') + ")", "gi");
                        return $('<div />').append(
                            $('<div />')
                                .addClass('autocomplete-suggestion')
                                .attr('data-val', feature.properties.label)
                                .attr('data-address-label', feature.properties.label)
                                .attr('data-address-name', feature.properties.name)
                                .attr('data-address-postcode', feature.properties.postcode)
                                .attr('data-address-city', feature.properties.city)
                                .html(feature.properties.label.replace(regexp, "<b>$1</b>"))
                        ).html();
                    },
                    onSelect: function (event, term, item) {
                        var $item = $(item);
                        inputs.label.val($item.data('address-label'));
                        inputs.name.val($item.data('address-name'));
                        inputs.postcode.val($item.data('address-postcode'));
                        inputs.city.val($item.data('address-city'));
                    }
                });
            })();

            $(document).on('change', 'select[name^=teaching]', function (e) {
                var $level = $(this).parent().parent().find('select[name^=level]');
                $level.find('option[value!=""]').remove();
                if ($(this).val()) {
                    var allowed = $(this).find('option:selected').data('levels') || {};
                    $.each(allowed, function (value, label) {
                        $level.append(
                            $('<option />').attr('value', value).text(label)
                        );
                    });
                }
            });

            $(this).on('blur', 'input.validate:not([type=checkbox], [type=radio]), select.validate', function () {
                $(this).closest('form').validate({ fields: this });
                console.log('4');
            });
            $(this).on('click', 'input.validate[type=checkbox], input.validate[type=radio]', function (event) {
                var $input = $(this);
                var $siblings = $input.closest('form').find('input[name=' + $input.attr('name') + ']');
                $siblings.closest('label').removeClass('selected');
                $siblings.filter(':checked').each(function () {
                    $(this).closest('label').addClass('selected');
                });
                $(this).closest('form').validate({ fields: this });
                console.log('5');
            });

            $(this).on('submit.validate', 'form.validate', function (e) {
                e.preventDefault();
                var $form = $(this);
                if ($form.validate({ fields: $form.find('input.validate, select.validate'), files: true, submit: true }, function (validated) {
                    validated && $(document).off('submit.validate') && $form.submit();
                }));
                console.log('6');
            });

            // $(this).on('blur', 'input.validate:not([type=file]), select.validate, textarea.validate', function() {
            //     $(this).closest('form').validate({fields: this, files: false});
            // });
            // $(this).on('change', 'input.validate[type=file]', function() {
            //     $(this).closest('form').validate({fields: this, files: true});
            // });

            // $(this).on('click', 'input[type=checkbox], input[type=radio]', function(event) {
            //     var $input = $(this);
            //     var $siblings = $input.closest('form').find('input[name=' + $input.attr('name') + ']');
            //     $siblings.closest('label').removeClass('selected');
            //     $siblings.filter(':checked').each(function() {
            //         $(this).closest('label').addClass('selected');
            //     });
            // });

            $(this).on('click', 'button', function (event) {
                console.log('1');
                event.preventDefault();
                var target = $(this).data('tab');
                var validate = $(this).data('validate');
                var step = $(this).data('step');
                var $tabs = $('.tab');
                var $steps = $('.step');
                var switchTab = function (target) {
                    $tabs.hide().removeClass('active');
                    $steps.removeClass('active');
                    $steps.removeClass('completed');
                    for (var i = 0; i < $steps.length; ++i) {
                        if ($($steps[i]).hasClass(target)) {
                            break;
                        }
                        $($steps[i]).addClass('completed');
                    }
                    $('.step.' + target).addClass('active').show();
                    $('.tab.' + target).addClass('active').show();
                    $('html, body').animate({
                        scrollTop: $section.offset().top
                    }, 250)
                }
                if (validate) {
                    console.log('2');
                    var $form = $(this).closest('form');
                    var $tab = $(this).closest('.tab');
                    $form.validate({
                        fields: $tab.find('input.validate, select.validate'),
                        files: true,
                        submit: true,
                        data: { step: step }
                    }, function (validated, response) {
                        console.log('3' + response.success + ' ' + response.message);
                        if (response.success && response.message) {
                            $form.empty().append(
                                $('<div class="feedback success">').html(response.message)
                            );

                            // commenté pour test 24-01-2024 
                            /*
                          (new Image()).src = '//www.googleadservices.com/pagead/conversion/1034324241/?label=Ie5GCNXAsgEQkZKa7QM';
                          ga && ga('send', 'event', {
                              eventCategory: 'form',
                              eventAction: 'submit',
                              eventLabel: 'step',
                              eventValue: 4
                          });
                          */
                        }
                        validated && step; // commenté pour test 24-01-2024 && ga && ga('send', 'pageview', '/contact/step-' + step);
                        validated && target && switchTab(target);

                        dataLayer.push({
                            'event': 'cf7submission'
                        });

                    });
                } else {
                    target && switchTab(target);
                }
            });

        });

    });

})(jQuery);